import React, { useState, useEffect } from "react";

import { Form } from "@sainsburys-tech/luna-form";
import {
  BLACK_BOX_ELEMENT_ID,
  reportError,
  SubmitButton,
} from "@jsainsburyplc/id-ui-common";

import { MFA_CODE_SENT } from "constants/mfaAndOtp";
import { getLoginLink } from "utils/urls";
import useCookies from "hooks/useCookies";

import {
  CHALLENGE,
  USERNAME,
  PASSWORD,
  LOGIN_AFTER_REGISTRATION_FORM_ID,
} from "../../constants/login";

import { isIovationEnabled } from "../../utils/env";

const getAndAssignBlackBoxToken = async (form) => {
  try {
    const bb = window.IGLOO.getBlackbox();
    if (bb && bb.finished) {
      form.elements[BLACK_BOX_ELEMENT_ID].value = bb.blackbox;
    } else {
      reportError("AutoLogin - the blackbox is not present!");
    }
  } catch (e) {
    reportError(
      `AutoLogin - error occurred during getAndAssignBlackBoxToken: ${e}`
    );
  }
};

const AutoLogInButton = ({ username, password, label = "Log in" }) => {
  const [isSubmitting, setIsSubmitting] = useState(undefined);
  const { loginChallenge } = useCookies();

  const isIovationEnabledEnv = isIovationEnabled();

  useEffect(() => {
    sessionStorage.removeItem(MFA_CODE_SENT);
  }, []);

  const onSubmit = async (e) => {
    e && e.preventDefault();
    setIsSubmitting(true);
    const form = document.getElementById(LOGIN_AFTER_REGISTRATION_FORM_ID);
    try {
      isIovationEnabledEnv && (await getAndAssignBlackBoxToken(form));
      form.submit();
    } catch (error) {
      console.log(error);
      form.submit();
    }
  };

  return (
    <Form
      method="post"
      onSubmit={onSubmit}
      action={getLoginLink()}
      id={LOGIN_AFTER_REGISTRATION_FORM_ID}
    >
      {isIovationEnabledEnv && (
        <input
          type="hidden"
          name={BLACK_BOX_ELEMENT_ID}
          id={BLACK_BOX_ELEMENT_ID}
          data-testid={BLACK_BOX_ELEMENT_ID}
        />
      )}
      <input type="hidden" name={CHALLENGE} defaultValue={loginChallenge} />
      <input type="hidden" name={USERNAME} defaultValue={username} />
      <input type="hidden" name={PASSWORD} defaultValue={password} />

      <SubmitButton
        style={{ maxWidth: undefined }}
        label={label}
        isLoading={isSubmitting}
        isLoadingLabel="Loading..."
        fullWidth={true}
      />
    </Form>
  );
};

export default AutoLogInButton;
